import templateStr from 'text!./templates/autopay-summary.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            firstPayment: '='
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/billing/bc3/directives/AutopaySummary.js
// module id = 2200
// module chunks = 0